// extracted by mini-css-extract-plugin
export default {"five":"SecFive_five__qCVw0"};